module.exports = __webpack_public_path__ + "img/boton-gastronomia.ba358ea9.jpg";